<template lang="pug">
.upload_box
  .upload_title
    .left 上传方式
      el-dropdown(@command="handleCommand" size="mini" placement="bottom")
        span {{typeName}}
          i.el-icon-caret-bottom.el-icon--right
        el-dropdown-menu(slot="dropdown")
          template(v-if="item.materialSourceTypeList")
            el-dropdown-item(:command="item.code" v-for="item in item.materialSourceTypeList" :key="item.code")
              span.title {{item.webName || item.name}}

    .fr.right
      span.bestpx 素材规格：{{item.materialSizeName}}

  .url(v-if="cmdCode == 5")
    el-dropdown(@command="handleSelect" size="mini" trigger="click" placement="bottom")
      el-input(v-model="url" placeholder="请选择" type="textarea" @keydown.native="curSltItem = {}" readonly)
      el-dropdown-menu(slot="dropdown")
        .list_ctn
          .data-none(v-if="!urlList.length") 暂无数据
          el-dropdown-item.els(v-for="(item, i) in urlList" :key="i" :command="item") {{item.materialName}}
            //- span ({{item.materialUrl}})

  Upload_v(v-else v-model="resourse" :data="item" :orderData="orderData" :type="cmdCode")

  //- materialType: 1 视频   2  图片
  .status(v-if="resourse && resourse.checkStatus")
    i.iconfont.icon-shenhezhong(v-if="item.checkStatus == 1")
    i.iconfont.icon-zhengque(v-else-if="item.checkStatus == 2")
    i.iconfont.icon-cuowu(v-else-if="item.checkStatus == 3")
    span.zhengque(v-if="item.checkStatus == 2") 审核通过
    span.cuowu(v-else-if="item.checkStatus == 3") 审核未通过，请重新上传
    span.shenhezhong(v-else) 审核中
    el-popover(width="200" placement="top")
      span {{item.reason || '暂无'}}
      span.fr(slot="reference" v-if="item.checkStatus == 3") 查看原因
</template>

<script>
import Upload_v from './UploadVideo_v'
let codeMap = {}
export default {
  name: 'UploadVideo_upbox',
  components: { Upload_v },
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    orderData: {
      type: Object,
      default() {
        return {}
      }
    },
    contentTime: {
      type: String | Number,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      resourse: {},
      type: '1', // 1:素材，   2:url
      typeName: '',
      url: '',
      urlList: [],
      curSltItem: {},
      curPage: 1,
      cmdCode: '',
      init: true
    }
  },
  computed: {
    showH5() {
      return (this.orderData.screenArea === 0 || this.orderData.screenArea === 4) && this.orderData.showScreenType === 1
      // return this.orderData.screenArea === 4 || (this.orderData.screenArea === 0 && this.orderData.showScreenType === 0)
    }
  },
  watch: {
    resourse(v) {
      v.screenType = this.item.screenType
      this.$emit('input', v)
    },
    url(v) {
      // 改成url 展示所选择名称
      let data = {
        ...this.curSltItem,
        materialContent: this.curSltItem.materialUrl,
        isUrl: true,
        screenType: this.orderData.screenArea == 4 ? 4 : 0, // 实时广告 H5 素材 screenType 传 4  正常广告素材（视频图片广告）screenType 传 0
        materialType: 5
      }
      this.$emit('input', data)
    },
    orderData: {
      immediate: true,
      handler(v) {
        if (v.screenArea - 0 === 4) {
          // 实时广告订单
          this.item.screenType = 4 // 返回的素材中的 h5 素材的screenType是5  导致后面匹配不上 这里暂手动改为 4
        }
        // let list = v && v.advContentDto && v.advContentDto.materialInfoList || []
        // let screenTypeArr = list.filter(el => el.screenType == this.item.screenType)
        // let curResource = screenTypeArr[0]
        let curResource = this.item
        if (curResource) {
          if (curResource.materialType == '5') {
            // H5形式素材
            curResource.materialUrl = curResource.materialContent
            this.curSltItem = curResource
            this.resourse = { ...curResource }
            this.url = curResource.materialName
            // console.log(this.url)
            return
          }
          let el = curResource
          this.resourse = {
            ...el,
            reourceAddress: el.materialContent,
            resourceName: el.materialName,
            contentSize: el.materialSize,
            typeCode: el.materialType,
            narrowImage: el.narrowImageUrl
          }
        }
      }
    }
  },
  async created() {
    // if (!this.urlList.length) this.getH5UrlList()
    // 上传方式 默认第一个
    let sltList = this.item.materialSourceTypeList
    if (sltList && sltList.length) {
      sltList.forEach((el) => {
        codeMap[el.code] = el
      })
      this.handleCommand(this.item.materialType) // 默认取和当前 item 类型一致
    }

    this.init = false
  },
  methods: {
    async getH5UrlList() {
      let load = this.$loading()
      let res = await this.fetch('/design/web/material/v2/searchMaterialPageInfo', {
        pageIndex: this.curPage,
        pageSize: 300,
        clienteleGuid: this.$store.state.customer.userInfo.customerId,
        contentTime: this.contentTime
      })
      load.close()
      if (res && res.data && res.data.list) {
        this.urlList = res.data.list
      }
    },
    handleCommand(v) {
      if (!codeMap[v]) v = '-1' // 首次渲染初始化 存在匹配不到的情况 当实际是图片或视频时 应为 -1 外层item的materialType属性返回是1 匹配不到 ，这里设为-1
      this.cmdCode = v + ''
      this.typeName = codeMap[v].webName || codeMap[v].name
      // 切换清空数据
      if (!this.init) {
        // 初始化也会走这里  初始化时如果由原来素材不清空
        this.url = ''
        this.resourse = {}
      }
      this.$emit('input', { materialType: v - 0 === -1 ? 1 : v })
      this.$forceUpdate()
    },
    handleSelect(data) {
      this.curSltItem = data
      this.resourse = data
      this.url = data.materialName
    }
  }
}
</script>

<style lang="sass" scoped>
.upload_box
    float: left
    width: 359px
    height: 290px
    background: #FFF
    border: 1px solid #e9e9e9
    vertical-align: top
    &:first-child
        margin-right: 10px
    .url
        height: calc(100% - 41px)
        padding: 10px
        ::v-deep .el-dropdown
            width: 100%
            height: 40px
    ::v-deep .el-textarea
        height: 100%
        textarea
            padding: 10px
            background: #F5F5F5
            border: 1px solid #e9e9e9
            border-bottom: none
            resize: none
            height: 100%
            color: #272829

.list_ctn
    width: 338px
    // width: 750px
    height: 240px
    overflow: auto

.upload_title
    padding: 0 10px
    border-bottom: 1px solid #E9E9E9
    display: flow-root
    .left
        float: left
        .img
            float: left
            width: 16px
            height: 16px
            margin-top: 10px
        .title
            font-size: 14px
            font-weight: 400
            color: #282729
            line-height: 40px
            margin: 0 10px 0 5px
        ::v-deep .el-dropdown
            margin-top: 10px
            margin-left: 10px
            cursor: pointer
    .right
        cursor: pointer
        color: #999
        float: right
        .bestpx
            font-size: 12px
            font-weight: 400
            line-height: 40px
        i
            margin: 5px 0 0 5px

.status
    background: #fff
    line-height: 38px
    text-align: left
    padding: 0 10px
    border-top: 1px solid #f5f5f5
    border-radius: 0 0 4px 4px
    i
        margin-right: 5px
    .fr
        color: #999
        cursor: pointer
        font-size: 12px
.icon-shenhezhong, .shenhezhong
    color: #FF7413
.icon-daishangchuan, .daishangchuan
    color: #999
.icon-zhengque, .zhengque
    color: #3FB536
.icon-cuowu, .cuowu
    color: #D50000
</style>
